import axios from 'axios';
import store from '../../store/index';

export default {
	getRoles(showDeleted) {
		return axios.get(`/api/roles?deleted=${showDeleted}`);
	},
	getPermissions() {
		return axios.get('/api/permissions/?sort=sort');
	},
	addRole(role) {
		return axios.post('/api/roles/', role);
	},
	updateRole(id, field, payload) {
		return axios.patch(`/api/roles/${id}`, { [field]: payload });
	},
	updateRoles(roles) {
		return axios.patch(`/api/roles/`, roles);
	},
	deleteRole(role) {
		return axios.delete(`/api/roles/${role.id}`);
	},
};
